module.exports = __webpack_public_path__ + "static/media/control-distancia-verde.555b6c81.png";